import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, ViewChild } from '@angular/core'
import { TrvModalRef } from "@trv-hub/trv-ng-common";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { LanguageService } from '@app/service/language.service';


@Component({
    selector: 'app-map-export-preview-modal',
    templateUrl: './map-export-preview-modal.component.html',
    styleUrls: ['./map-export-preview-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class MapExportPreviewModalComponent {
    public src = "";
	private previousSrc:string = "";
    public isPng = false;

    download: EventEmitter<null> = new EventEmitter<null>();

    constructor(
        private modalRef: TrvModalRef<MapExportPreviewModalComponent>,
        private sanitizer: DomSanitizer,
        private cdr: ChangeDetectorRef,
        public lang: LanguageService
    ) {}

    

    close(): void {
        this.modalRef.close();
    }

    dismiss(): void {
        this.modalRef.dismiss();
    }

    public setSource(src: string): void {
		this.cdr.detach();
		if (this.previousSrc !== src) {
			this.src = src;
			this.previousSrc = src;
			this.cdr.detectChanges();
		}
	}

    public getSafeUrl(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
